// extracted by mini-css-extract-plugin
export default {"root":"yb9Cam","list":"MFq9Uf","icon-button":"RDIWa2","iconButton":"RDIWa2","create-post-card":"PGsbJo","createPostCard":"PGsbJo"};